import React, { useEffect } from "react";
import { Box, Typography, useMediaQuery } from "@mui/material";
import Logo from "../../../../_default/Logo";
import siteData from "../../../../../_data";
import { useLayout } from "../../../../_context/DefaultProvider";
import SidebarDrawerHeader from "../../../../_default/SidebarDrawerHeader";
import useSmoothResponsiveFontSize from "../../../../../_hook/useSmoothResponsiveFontSize";

const LeftNavHeader = (props) => {
  const { drawerStates } = useLayout();
  const { brand } = siteData;
  const isMobileView = useMediaQuery((theme) => theme.breakpoints.down("md"));
  const customfontsize = useSmoothResponsiveFontSize({});

  useEffect(() => {}, [customfontsize]);
  return (
    <SidebarDrawerHeader   iconName={"menu"} {...props} isshowclosedbutton={drawerStates?.isExpanded}>
      {({currentwidth,}) => {
        return(
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'start' }}>
           <Logo
          src={brand.logoSrc}
          alt={`${brand.name} - Logo image is missing`}
          style={{
            width: `${(!drawerStates?.isExpanded?currentwidth:currentwidth*0.3)}px`,
            height: `${!drawerStates?.isExpanded?currentwidth:currentwidth*0.3}px`,
            border: (theme) => `2px solid ${theme.palette.text.dark}`,
          }}
        />
              {drawerStates?.isExpanded && (
          <Box
            sx={{
              width: `${currentwidth*.6}px`,
              paddingLeft: 2,
            }}
          >
            <Typography
            
              sx={{
                fontWeight: "bold",
                fontSize:`${customfontsize}px`,
                lineHeight: `${customfontsize}px`,
                color: "grey.100",
                ...(!isMobileView && {
                  display: "-webkit-box",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  WebkitLineClamp: 3, // Limit to two lines
                  WebkitBoxOrient: "vertical",
                
                }),
              
              }}
            >
              {brand.name}
            </Typography>
          </Box>
        )}
        </Box>
      )}}
    </SidebarDrawerHeader>
  );
};

export default LeftNavHeader;
